/**
 * tm/dealOutlook.ts — 동행상담 계약 가능성 한 벌 (2026-10-29 지도사 「미팅 다녀와서 계약 가능성 · 이유 · WM님이 그 달에 계약 유망을 직관적으로」)
 *  서버 services/consultDeal.OUTLOOKS 와 같은 세 단계 · 화면 이름표와 색은 여기서만(상담 결과 · WM 포털이 같이 쓴다)
 */
export type DealOutlook = '유망' | '보통' | '어려움';
export const OUTLOOKS: DealOutlook[] = ['유망', '보통', '어려움'];
export const OUTLOOK_LABEL: Record<DealOutlook, string> = { 유망: '계약 유망', 보통: '보통', 어려움: '어려움' };
/** 표시 색 — 유망 = 초록 · 보통 = 주황 · 어려움 = 회색(빨강은 오류처럼 보여 쓰지 않음) */
export const OUTLOOK_TONE: Record<DealOutlook, { fg: string; bg: string }> = {
  유망: { fg: '#0F766E', bg: '#E6F4F1' },
  보통: { fg: '#B45309', bg: '#FEF3E2' },
  어려움: { fg: '#64748B', bg: '#F1F5F9' },
};
export function asOutlook(v: unknown): DealOutlook | null { return OUTLOOKS.includes(v as DealOutlook) ? (v as DealOutlook) : null; }
